import { Entity, Column, PrimaryGeneratedColumn, OneToMany } from 'typeorm'

import QuestionConfiguration from './QuestionConfiguration'
import OptionConfiguration from './OptionConfiguration'

@Entity('config_livecharts_tests')
export default class TestConfiguration {
  @PrimaryGeneratedColumn('uuid')
  id!: string

  @Column({ name: 'created_at' })
  createdAt!: Date

  @Column({ name: 'workspace_id' })
  workspaceId!: string

  @Column({ name: 'test_id' })
  testId!: string

  @Column({ type: 'text', array: true, name: 'findings' })
  findings?: string[]

  @Column({ name: 'created_by' })
  createdBy!: string

  @Column({ name: 'shared_link_hash' })
  sharedLinkHash?: string

  @OneToMany(type => QuestionConfiguration, questionConfiguration => questionConfiguration.testConfig)
  questionConfigs!: QuestionConfiguration[]

  @OneToMany(type => OptionConfiguration, optionConfiguration => optionConfiguration.testConfig)
  optionConfigs!: OptionConfiguration[]
}
